/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<1ce9bc4c7100d83801c2a74b8a28eb13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpCenterAnnouncementFragment$data = {
  readonly header: string | null | undefined;
  readonly message: string | null | undefined;
  readonly " $fragmentType": "helpCenterAnnouncementFragment";
};
export type helpCenterAnnouncementFragment$key = {
  readonly " $data"?: helpCenterAnnouncementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpCenterAnnouncementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "helpCenterAnnouncementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "HelpLayoutAnnouncementElement",
  "abstractKey": null
};

(node as any).hash = "7a1ed4e240ff1dc0c102abd9318b56ae";

export default node;
